import en from "./en.translation.json";
import es from "./es.translation.json";
import homeScreenTemplate from "./homescreen.html";
import _ from "lodash";
import {
    growerPaperworkState,
    growerSafetyMeetingsBaseState,
} from "../../../../base.routes";

class HomeScreenController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        let ctrl = this;
        ctrl.safetyMeetingRequestsByGrower = _.groupBy(
            ctrl.safetyMeetingRequests,
            "requester",
        );
        ctrl.myPaperwork = {};
        for (let grower of ctrl.growers) {
            let allPaperworkForGrower = _.concat(
                _.filter(ctrl.newPaperworkWaitingForPrefill, [
                    "documentRequest.requester",
                    grower.sid,
                ]),
                _.filter(ctrl.oldPaperworkToStart, [
                    "documentRequest.requester",
                    grower.sid,
                ]),
                _.filter(ctrl.paperworkV3ToSign, [
                    "documentRequest.requester",
                    grower.sid,
                ]),
            );
            ctrl.myPaperwork[grower.sid] = allPaperworkForGrower;
        }
    }

    goToPaperwork(grower) {
        let ctrl = this;
        ctrl.showPaperworkSpinner = true;
        ctrl.$state.go(growerPaperworkState, { grower_sid: grower.sid });
    }

    goToTraining(grower) {
        let ctrl = this;
        ctrl.showTrainingSpinner = true;
        ctrl.$state.go(growerSafetyMeetingsBaseState, {
            grower_sid: grower.sid,
        });
    }
}

export default {
    bindings: {
        account: "<",
        activeMemberships: "<",
        groups: "<",
        safetyMeetingRequests: "<",
        growers: "<",
        managedGrowers: "<",
        managedCrewsData: "<",
        newPaperworkWaitingForPrefill: "<",
        oldPaperworkToStart: "<",
        paperworkV3ToSign: "<",
    },
    template: homeScreenTemplate,
    name: "homeScreen",
    translations: { en, es },
    controller: HomeScreenController,
};
